import "./styles.css";
import { initColorPicker } from "./color-picker";
import { sanitizeSubdomain, validateIntakeForm } from "./validation";

const form = document.querySelector<HTMLFormElement>("#demo-form");
const clientCompanyInput = document.querySelector<HTMLInputElement>("#client_company_name");
const subdomainInput = document.querySelector<HTMLInputElement>("#requested_subdomain");
const logoInput = document.querySelector<HTMLInputElement>("#company_logo");
const subjectInput = document.querySelector<HTMLInputElement>("#form-subject");
const sanitizedSubdomainInput =
  document.querySelector<HTMLInputElement>("#sanitized_subdomain");
const primaryPreview = document.querySelector<HTMLSpanElement>("#subdomain-preview");
const inlinePreview = document.querySelector<HTMLSpanElement>("#inline-subdomain-preview");
const companyTitlePreview =
  document.querySelector<HTMLElement>("#company-title-preview");
const formStatus = document.querySelector<HTMLElement>("#form-status");
const logoPreviewImage = document.querySelector<HTMLImageElement>("#logo-preview-image");
const logoPreviewPlaceholder =
  document.querySelector<HTMLSpanElement>("#logo-preview-placeholder");
const localHosts = new Set(["localhost", "127.0.0.1", "::1"]);
const defaultSubdomainPreview = "exampleco";
let logoPreviewUrl: string | null = null;

function getCompanySubject(value: string): string {
  return `Prototype Demo request for: ${value.trim() || "Example Company, Inc."}`;
}

function updateSubject(value: string): void {
  if (subjectInput) {
    subjectInput.value = getCompanySubject(value);
  }
}

function updateCompanyTitlePreview(value: string): void {
  if (companyTitlePreview) {
    companyTitlePreview.textContent = value.trim() || "Company Name";
  }
}

function setPreviewText(value: string): void {
  const preview = sanitizeSubdomain(value) || defaultSubdomainPreview;

  if (primaryPreview) {
    primaryPreview.textContent = preview;
  }

  if (inlinePreview) {
    inlinePreview.textContent = preview;
  }

  if (sanitizedSubdomainInput) {
    sanitizedSubdomainInput.value = sanitizeSubdomain(value);
  }
}

function resetLogoPreview(): void {
  if (logoPreviewUrl) {
    URL.revokeObjectURL(logoPreviewUrl);
    logoPreviewUrl = null;
  }

  if (logoPreviewImage) {
    logoPreviewImage.hidden = true;
    logoPreviewImage.removeAttribute("src");
  }

  if (logoPreviewPlaceholder) {
    logoPreviewPlaceholder.hidden = false;
  }
}

function updateLogoPreview(file: File | null): void {
  resetLogoPreview();

  if (!file || !["image/png", "image/jpeg"].includes(file.type)) {
    return;
  }

  logoPreviewUrl = URL.createObjectURL(file);

  if (logoPreviewImage) {
    logoPreviewImage.src = logoPreviewUrl;
    logoPreviewImage.hidden = false;
  }

  if (logoPreviewPlaceholder) {
    logoPreviewPlaceholder.hidden = true;
  }
}

function setError(field: string, message = ""): void {
  const errorElement = document.querySelector<HTMLElement>(`#${field}-error`);

  if (errorElement) {
    errorElement.textContent = message;
  }
}

function clearErrors(): void {
  [
    "broker_email",
    "client_company_name",
    "requested_subdomain",
    "company_logo",
    "brand_colors"
  ].forEach((field) => setError(field));

  if (formStatus) {
    formStatus.textContent = "";
  }
}

subdomainInput?.addEventListener("input", (event) => {
  setPreviewText((event.currentTarget as HTMLInputElement).value);
});

clientCompanyInput?.addEventListener("input", (event) => {
  const value = (event.currentTarget as HTMLInputElement).value;
  updateSubject(value);
  updateCompanyTitlePreview(value);
});

logoInput?.addEventListener("change", (event) => {
  const input = event.currentTarget as HTMLInputElement;
  updateLogoPreview(input.files?.[0] ?? null);
});

initColorPicker({ onError: setError });

form?.addEventListener("submit", (event) => {
  clearErrors();

  const result = validateIntakeForm(new FormData(form));
  updateSubject(clientCompanyInput?.value ?? "");

  if (sanitizedSubdomainInput) {
    sanitizedSubdomainInput.value = result.sanitizedSubdomain;
  }

  if (!result.isValid) {
    event.preventDefault();

    Object.entries(result.errors).forEach(([field, message]) => {
      setError(field, message);
    });

    const firstInvalidField = Object.keys(result.errors)[0];
    const control = document.querySelector<HTMLElement>(`#${firstInvalidField}`);
    control?.focus();
    return;
  }

  const brokerEmail = new FormData(form).get("broker_email");

  if (typeof brokerEmail === "string") {
    window.sessionStorage.setItem("omegaDemoContactEmail", brokerEmail.trim());
  }

  if (localHosts.has(window.location.hostname)) {
    event.preventDefault();

    window.location.assign("/success/");
  }
});

setPreviewText(subdomainInput?.value ?? "");
updateSubject(clientCompanyInput?.value ?? "");
updateCompanyTitlePreview(clientCompanyInput?.value ?? "");
